module.exports = __webpack_public_path__ + "media/images/badge/giorno-da-leoni-de241eaee7cbd87fe069ce18bf98b254.png";